import { useQuery } from 'react-query';
import { getFanLetters } from '../../services/bettieFanLettersService';
import type { UseQueryOptions } from 'react-query';
import type {
  GetFanLettersQuery,
  GetFanLettersResponse
} from '../../services/bettieFanLettersService';

export function useGetFanLetters(
  query: GetFanLettersQuery,
  options?: UseQueryOptions<GetFanLettersResponse, Error>
) {
  return useQuery<GetFanLettersResponse, Error>(
    ['fanLetters', query?.chat_room_id, query?.only_unseen],
    () => getFanLetters({ query }),
    {
      staleTime: 60 * 1000,
      cacheTime: 5 * 60 * 1000,
      ...options
    }
  );
}
